import React from 'react';
import { Modal, Button } from '@block/plug';
import { CertificateType } from '../../types';
import { ConfirmModalState } from './types';

interface ConfirmModalProps {
  state: ConfirmModalState;
  certificateType: CertificateType;
  onOk: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({ state, certificateType, onOk, onCancel }) => {
  if (!state.visible) return null;

  return (
    <Modal title="信息核查" onClose={onCancel} style={{ width: '400px' }}>
      <Modal.Body>
        <div>
          <p>根据上传文件识别出以下结果，是否应用？</p>
          <p>{certificateType === CertificateType.Diploma ? '学历证书编码' : '学位证书编码'}</p>
          <p>识别结果：{state.ocrCode}</p>
          {state.currentCode ? <p>你所填写：{state.currentCode}</p> : null}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
        <Button onClick={onCancel}>取消</Button>
        <Button type="primary" onClick={onOk}>
          应用
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
